// extracted by mini-css-extract-plugin
export default {"button":"OfferPdfButton_button__vmUo1"};